"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketPlaceService = void 0;
const axios_1 = __importDefault(require("axios"));
const environment_1 = require("../../constants/environment");
const environment_enum_1 = require("../enum/environment.enum");
class MarketPlaceService {
    constructor(ENV = environment_enum_1.ENVIRONMENT.DEV, key, token = '') {
        this.getUserShoppingBag = async (user) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/shopping-bag/${user.ou}/user/${user.person_id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.deleteShoppingBagItem = async (user, concepto, body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/shopping-bag/${user.ou}/items/${concepto.id}`;
            const response = await axios_1.default.delete(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getCourses = async (params) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/courses`;
            const objectToQueryString = (obj) => {
                return Object.keys(obj).map(key => `${key}=${obj[key]}`).join("&");
            };
            const path = params ? `${URL}?${objectToQueryString(params)}` : URL;
            const response = await axios_1.default.get(path, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.postCoursesSync = async (body, user) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/courses/sync/${user.ou}`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getUserCourses = async (user) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/user/${user.person_id}/courses`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getUserFavoriteCourses = async (user) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/user/${user.person_id}/courses/favorites`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.deleteCourse = async (id, body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/courses/${id}`;
            const response = await axios_1.default.delete(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.postCourseStatus = async (id, body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/courses/${id}/status`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getStudentProgress = async (user) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/user/${user.person_id}/courses/progress`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.postCheckout = async (user, body) => {
            var _a;
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/checkout/v3/${user.person_id}/${user.ou}/`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
            else {
                const data = (_a = response === null || response === void 0 ? void 0 : response.response) === null || _a === void 0 ? void 0 : _a.data;
                const error = data || response.statusText;
                return Promise.reject(error);
            }
            ;
        };
        this.createOrder = async (user, body) => {
            var _a;
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/checkout/v3/${user.person_id}/order`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
            else {
                const data = (_a = response === null || response === void 0 ? void 0 : response.response) === null || _a === void 0 ? void 0 : _a.data;
                const error = data || response.statusText;
                return Promise.reject(error);
            }
            ;
        };
        this.registerUpdateOrder = async (user, body) => {
            var _a;
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/checkout/v3/${user.person_id}/registerupdateorder`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
            else {
                const data = (_a = response === null || response === void 0 ? void 0 : response.response) === null || _a === void 0 ? void 0 : _a.data;
                const error = data || response.statusText;
                return Promise.reject(error);
            }
            ;
        };
        this.payOrder = async (user, body) => {
            var _a;
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/checkout/v3/${user.person_id}/order/pay`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
            else {
                const data = (_a = response === null || response === void 0 ? void 0 : response.response) === null || _a === void 0 ? void 0 : _a.data;
                const error = data || response.statusText;
                return Promise.reject(error);
            }
            ;
        };
        this.createMobileSalesOrder = async (body) => {
            var _a;
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/orders/mobile`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
            else {
                const data = (_a = response === null || response === void 0 ? void 0 : response.response) === null || _a === void 0 ? void 0 : _a.data;
                const error = data || response.statusText;
                return Promise.reject(error);
            }
            ;
        };
        this.getMobileSalesOrders = async (person_id, order_id) => {
            var _a;
            let URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/orders/mobile?person_id=${person_id}`;
            if (order_id) {
                URL += `&order_id=${order_id}`;
            }
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
            else {
                const data = (_a = response === null || response === void 0 ? void 0 : response.response) === null || _a === void 0 ? void 0 : _a.data;
                const error = data || response.statusText;
                return Promise.reject(error);
            }
            ;
        };
        this.postApplyBannerPayment = async (orderId) => {
            var _a;
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/orders/${orderId}/banner-ficha-carrito`;
            const response = await axios_1.default.post(URL, JSON.stringify({}), { headers: { 'x-api-key': this.KEY } });
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
            else {
                const data = (_a = response === null || response === void 0 ? void 0 : response.response) === null || _a === void 0 ? void 0 : _a.data;
                const error = data || response.statusText;
                return Promise.reject(error);
            }
            ;
        };
        this.postConektaPayments = async (body) => {
            var _a;
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/conekta/undefined/payments`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
            else {
                const data = (_a = response === null || response === void 0 ? void 0 : response.response) === null || _a === void 0 ? void 0 : _a.data;
                const error = data || response.statusText;
                return Promise.reject(error);
            }
            ;
            //return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getCoursesPagination = async (ou, params) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/catalog/${ou}/courses`;
            const objectToQueryString = (obj) => {
                return Object.keys(obj).map(key => `${key}=${obj[key]}`).join("&");
            };
            const path = params ? `${URL}?${objectToQueryString(params)}` : URL;
            const response = await axios_1.default.get(path, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.postShoppingBagItem = async (user, body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/shopping-bag/${user.ou}/items`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.postFavorite = async (body, action) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/courses/favorite/${action}`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getCourse = async (id, params) => {
            const url = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/courses/${id}`;
            const objectToQueryString = (obj) => {
                return Object.keys(obj).map(key => `${key}=${obj[key]}`).join("&");
            };
            const path = params ? `${url}?${objectToQueryString(params)}` : url;
            const response = await axios_1.default.get(path, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getCourseNewGroupId = async () => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/courses/newgroupid`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getAdminOrders = async () => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/orders/status`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.newCourseBulk = async (rows) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/courses/bulk`;
            const response = await axios_1.default.post(URL, JSON.stringify({ body: rows }), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.newCourse = async (body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/courses`;
            const response = await axios_1.default.post(URL, body, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getInstructor = async (id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/instructors/${id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.putInstructor = async (id, body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/instructors/${id}`;
            const response = await axios_1.default.put(URL, JSON.stringify({ body: JSON.stringify(body) }), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.searchCourse = async (value) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/search/${value.replace(/\s/g, '+')}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.filterSearchCourse = async (body, page, pageSize, abort) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/search?page=${page}&pageSize=${pageSize}`;
            try {
                const response = await axios_1.default.post(URL, body, { headers: { 'x-api-key': this.KEY }, signal: abort ? abort.signal : null });
                return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
            }
            catch (error) {
                console.log('Error', error);
                return Promise.reject(500);
            }
        };
        //CURIEL
        this.searchDataV2 = async (body, params, abort) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/search/filters`;
            const path = !!params ? `${URL}?${this.objectToQueryString(params)}` : URL;
            const response = await axios_1.default.post(path, JSON.stringify(body), { headers: { 'x-api-key': this.KEY }, signal: abort ? abort.signal : null });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.searchCourseFix = async (key, value, page, pageSize, personId) => {
            let URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/search?${key}=${value}&page=${page}&pageSize=${pageSize}`;
            if (personId) {
                URL = URL + `&personId=${personId}`;
            }
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.filterSearchCourseFix = async (body, page, pageSize) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/search?page=${page}&pageSize=${pageSize}`;
            const response = await axios_1.default.post(URL, body, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getCourseLevelCat = async () => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/catalogs/catalog/CourseLevelCat`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getCourseInscriptions = async (id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/courses/${id}/inscriptions`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.postRating = async (body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/courses/rating`;
            const response = await axios_1.default.post(URL, JSON.stringify({ body: body }), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getCoursesRecommended = async (opName, personId, pageNumber, pageSize) => {
            const queryString = this.objectToQueryString({ op_name: opName, page_no: pageNumber, page_size: pageSize, person_id: personId });
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/catalog/null/courses?${queryString}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        // postConektaCheckout = async (body:any):Promise<any> => {
        //     const URL = `${API_URL_BASE}/${this.ENV}/market-place/conekta/undefined/checkout`;
        //     const response = await axios.post(URL, JSON.stringify({body: body}), { headers: { 'x-api-key': this.KEY } });
        //     return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        // };
        this.updateCourse = async (id, body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/courses/${id}`;
            const response = await axios_1.default.put(URL, body, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        // postCoursesSync = async (body:any, user:UserMarketPlace):Promise<any> => {
        //     const URL = `${API_URL_BASE}/${this.ENV}/market-place/courses/sync/${user.ou}`;
        //     const response = await axios.post(URL, JSON.stringify({body: body}), { headers: { 'x-api-key': this.KEY } });
        //     return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        // };
        this.getInstructors = async () => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/instructors`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getOrderDetails = async (id, person_id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/orders/${id}&person_id=${person_id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getOrderByPaymentToken = async (payment_token) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/orders/token`;
            const response = await axios_1.default.post(URL, JSON.stringify({ payment_token }), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        //Apply coupon in the checkout 
        this.postCoupon = async (coupon, body) => {
            var _a;
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/checkout/coupon/${coupon}/`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
            else {
                const data = (_a = response === null || response === void 0 ? void 0 : response.response) === null || _a === void 0 ? void 0 : _a.data;
                const error = data || response.statusText;
                return Promise.reject(error);
            }
            ;
        };
        // Remove coupon from order at checkout
        this.removeCouponOrder = async (coupon, body) => {
            var _a;
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/checkout/coupons/${coupon}/remove`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
            else {
                const data = (_a = response === null || response === void 0 ? void 0 : response.response) === null || _a === void 0 ? void 0 : _a.data;
                const error = data || response.statusText;
                return Promise.reject(error);
            }
            ;
        };
        this.deleteCoupon = async (coupon_id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/discounts/${coupon_id}/`;
            const response = await axios_1.default.delete(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.newCoupon = async (body) => {
            var _a;
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/discounts`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
            else {
                const data = (_a = response === null || response === void 0 ? void 0 : response.response) === null || _a === void 0 ? void 0 : _a.data;
                const error = data || response.statusText;
                return Promise.reject(error);
            }
            ;
        };
        this.updateCoupon = async (coupon_id, body) => {
            var _a;
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/discounts/${coupon_id}/`;
            const response = await axios_1.default.put(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
            else {
                const data = (_a = response === null || response === void 0 ? void 0 : response.response) === null || _a === void 0 ? void 0 : _a.data;
                const error = data || response.statusText;
                return Promise.reject(error);
            }
            ;
        };
        this.getCoupon = async (coupon_id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/discounts/${coupon_id}/`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getCouponsList = async () => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/discounts`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.postUpdateConektaOrder = async (body) => {
            var _a;
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/checkout/feeplan/updateorder`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
            else {
                const data = (_a = response === null || response === void 0 ? void 0 : response.response) === null || _a === void 0 ? void 0 : _a.data;
                const error = data || response.statusText;
                return Promise.reject(error);
            }
            ;
            //return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.neoRetryAddStudentToClass = async (order_id, body) => {
            var _a;
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/orders/${order_id}/neo/retry-enroll-class`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
            else {
                const data = (_a = response === null || response === void 0 ? void 0 : response.response) === null || _a === void 0 ? void 0 : _a.data;
                const error = data || response.statusText;
                return Promise.reject(error);
            }
            ;
        };
        this.getMemberships = async () => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/memberships`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getPersonMembership = async (user_id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/memberships/${user_id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.postProspectCRM = async (body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/courses/prospect`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.putProspectCRM = async (body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/courses/prospect`;
            const response = await axios_1.default.put(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.objectToQueryString = (obj) => Object.keys(obj).map(key => {
            const value = obj[key];
            let parameter = `${key}=${value}`;
            if (Array.isArray(value)) {
                let multiValueParams = '';
                const lastIndex = value.length - 1;
                value.forEach((item, index) => multiValueParams += `${key}=${item}${index === lastIndex ? '' : '&'}`);
                return multiValueParams;
            }
            return parameter;
        }).join("&");
        this.generateCheckoutToken = async (body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/checkout/tokens`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.decodeCheckoutToken = async (token) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/checkout/tokens/decode`;
            const response = await axios_1.default.post(URL, JSON.stringify({ token }), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getConektaPublicKeys = async () => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/conekta/keys`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.ENV = ENV;
        this.KEY = key;
        this.token = token;
    }
}
exports.MarketPlaceService = MarketPlaceService;
